export const Spin = () => (
  <div className="flex-row-center w-full h-full bg-textcolor/black/10">
    <div className="flex-col-center w-[100px] h-[100px]">
      <div className="dots-loader" />
    </div>
  </div>
);
